(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ws-category-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ws-category-carousel'))customElements.define('ws-category-carousel',class extends HTMLElement{
  connectedCallback(){
    this.track=this.querySelector('.ws-category-edit__track');
    if(!this.track)return;
    this.abort=new AbortController();
    const options={signal:this.abort.signal};
    this.update=()=>{this.track.tabIndex=this.track.scrollWidth-this.track.clientWidth>2?0:-1;};
    this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();const card=this.track.querySelector('.ws-category-edit__card');if(!card)return;const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.track.scrollBy({left:(event.key==='ArrowRight'?1:-1)*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}},options);
    this.track.addEventListener('focusin',event=>{const card=event.target.closest('.ws-category-edit__card');if(card)card.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});},options);
    document.addEventListener('shopify:block:select',event=>{if(this.track.contains(event.target))event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});},options);
    this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

})();
